import { render, staticRenderFns } from "./EmailDomainModal.vue?vue&type=template&id=9d615d7a&"
import script from "./EmailDomainModal.vue?vue&type=script&lang=js&"
export * from "./EmailDomainModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports